import React from "react";
import { List } from "../modules/Settings/Badges";

export function BadgesListPage() {
  return <List />;
}
